import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../data/salesContent';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-148" data-mp="3pfv7pj56kgtv">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-ink-900/95 px-4 py-3 backdrop-blur lg:hidden" data-id="element-149" data-mp="3ucvexxdrnpmk">
          <div className="mx-auto flex max-w-xl items-center gap-3" data-id="element-150" data-mp="c4w6g8t6nwqb">
            <div className="min-w-0 leading-tight" data-id="element-151" data-mp="gyiko5ezw8o8">
              <p className="font-display text-xl font-bold text-white" data-id="element-152" data-mp="75vtnhlvexbv">$27</p>
              <p className="truncate text-[11px] text-muted" data-id="element-153" data-mp="73t4t0wgfa8q">6 Vols + 4 Bonuses</p>
            </div>
            <a href={CHECKOUT_URL} className="flex-1 rounded-full bg-gold px-4 py-3 text-center text-sm font-bold text-ink-900 transition-colors duration-150 ease-out hover:bg-gold-dark" data-id="element-154" data-mp="24pzdfckb208">
              GET INSTANT ACCESS
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}